import { SisabPreliminaryReport } from "@/@types/app/sisabPreliminaryReport";
import { appApi } from "../api";

type GetUploadedReportsParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
};

type UploadHealthInformationSystemForPrimaryCareProps = {
	uf: string;
	ibgeCode: string;
	cnes: string;
	quarter: string;
	fileType: string;
	file: File;
};

export async function getUploadedReports({ uf, ibgeCode, cnes }: GetUploadedReportsParams) {
	const { data } = await appApi.get<SisabPreliminaryReport[]>(
		`/uf/${uf}/city/${ibgeCode}/sisabpreliminaryreport`,
		{
			cnes,
		}
	);
	return data || [];
}

export async function uploadHealthInformationSystemForPrimaryCare({
	uf,
	ibgeCode,
	file,
	...params
}: UploadHealthInformationSystemForPrimaryCareProps) {
	const formData = new FormData();
	formData.append("file", file);
	const response = await appApi.post(
		`/uf/${uf}/city/${ibgeCode}/SisabPreliminaryReport`,
		formData,
		{
			params,
		}
	);

	return Boolean(response.data);
}
